module.exports = __webpack_public_path__ + "img/feature01.c985f44.jpg";